import React, { useEffect } from 'react';
import {
  ListingDetailsType,
  CustomFieldsType,
  addListingDetailsType,
} from '~addListing/types';
import { useFormContext } from 'react-hook-form';
import { Input } from '@aqarmap/aqarmap-ui';
import { useTranslation } from 'react-i18next';
import { handleAttributeChange } from '~addListing/utils/handleAttributeChange';

const Floors = ({
  listing,
  customFieldsData,
  errorAttributeIds,
  setErrorAttributeIds,
}: {
  listing: ListingDetailsType;
  customFieldsData: { attributes: CustomFieldsType[] };
  errorAttributeIds: number[];
  setErrorAttributeIds: React.Dispatch<React.SetStateAction<number[]>>;
}) => {
  const floorsKey = 'floors';
  const { t } = useTranslation('app');
  const listingPropertyTypeId = listing?.property_type.id;
  const floorsData = customFieldsData.attributes?.find(
    (field: CustomFieldsType) => field.name === floorsKey,
  );
  const floorsDataId = Number(floorsData?.id);
  const isError = errorAttributeIds.includes(floorsDataId);

  const renderFloors = Object.values(
    floorsData?.virtualPropertyTypesIds || {},
  ).includes(listingPropertyTypeId);

  const { setValue, getValues } = useFormContext<addListingDetailsType>();
  const defaultFloorsValue =
    listing?.attributes.find((att) => att.custom_field.id === floorsDataId)
      ?.value || 0;

  if (!renderFloors) return null;

  useEffect(() => {
    setValue(
      'attributes',
      handleAttributeChange(
        getValues('attributes'),
        floorsDataId,
        defaultFloorsValue,
      ),
    );
  }, [isError]);

  return (
    <Input
      label={{
        text: t('floors'),
        className: 'text-title_4 text-black',
      }}
      field={{
        placeholder: t('floorsPlaceholder'),
        className:
          'text-gray__dark_2 text-gray__dark_2 placeholder:text-gray__dark_1 [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none [&::-moz-appearance:textfield]',
        type: 'number',
        defaultValue: defaultFloorsValue !== 0 ? defaultFloorsValue : '',
        onChange: (e) => {
          const value = Number(e.target.value);
          if (value >= 0)
            handleAttributeChange(getValues('attributes'), floorsDataId, value);
          else handleAttributeChange(getValues('attributes'), floorsDataId, 0);
        },
        min: 0,
        onFocus: () =>
          setErrorAttributeIds((prev) =>
            prev.filter((id) => id !== floorsDataId),
          ),
        onWheel: (e) => (e.target as HTMLInputElement).blur(),
      }}
      error={isError ? t('floorsError') : ''}
    />
  );
};

export default Floors;
